import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const CryptoService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const encrypt = (text) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/encrypt`, text, {
      headers,
    });
  };

  const decrypt = (text) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    return axios.post(`${BASE_URL}/decrypt`, text, {
      headers,
    });
  };

  service.encrypt = encrypt;
  service.decrypt = decrypt;

  return service;
})();

export default CryptoService;
